import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {PageComponent} from '../../page.component';
import {FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatStepper} from '@angular/material/stepper';

@Component({
  selector: 'mp-activate-account',
  templateUrl: 'activate-account.component.html',
  styleUrls: ['activate-account.component.css']
})
export class ActivateAccountComponent extends PageComponent implements OnInit {
  @ViewChild('stepper') private stepper: MatStepper;

  fgActivationCode: FormGroup;
  fgEmail: FormGroup;
  fgPassword: FormGroup;
  ctrlActivationCode = new FormControl('', [Validators.required]);
  ctrlEmail = new FormControl('', [Validators.required, Validators.email]);
  ctrlPassword1 = new FormControl('', [Validators.required, this.validatePasswordStrong()]);
  ctrlPassword2 = new FormControl('', [Validators.required, this.validatePasswordsEqual()]);
  loading = false;
  finished = false;

  errFailure: boolean;
  errNotEqual: boolean;
  errWeak: boolean;
  errInvalidKey: boolean;

  prefilledActivationKey = false;
  prefilledEmail = false;

  passwordForExistingBenutzer = false;

  constructor(private formBuilder: FormBuilder,
              private readonly apiService: ApiService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    super();
  }

  isLightPage(): boolean {
    return true;
  }

  canGoBack(): boolean {
    return false;
  }

  ngOnInit(): void {
    this.fgActivationCode = this.formBuilder.group({
      activationCode: this.ctrlActivationCode,
    });

    this.fgEmail = this.formBuilder.group({
      email: this.ctrlEmail,
    });

    this.fgPassword = this.formBuilder.group({
      password1: this.ctrlPassword1,
      password2: this.ctrlPassword2
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.key !== undefined) {
        this.prefilledActivationKey = true;
        this.ctrlActivationCode.setValue(params.key);
        this.ctrlActivationCode.disable();
      }

      if (params.email !== undefined) {
        this.prefilledEmail = true;
        this.ctrlEmail.setValue(params.email);
      }
    });

    this.resetErrors();
  }

  validatePasswordStrong(): ValidatorFn {
    return x => {

      if (this.passwordForExistingBenutzer) {
        return null;
      }

      const p = x.value;

      if (p.length < 8) {
        return {message: 'Das Passwort ist zu kurz'};
      }

      if (!/\d/.test(p)) {
        return {message: 'Das Passwort muss eine Ziffer enthalten'};
      }

      if (!/[a-z]/.test(p)) {
        return {message: 'Das Passwort muss einen Kleinbuchstaben enthalten'};
      }

      if (!/[A-Z]/.test(p)) {
        return {message: 'Das Passwort muss einen Großbuchstaben enthalten'};
      }

      if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(p)) {
        return {message: 'Das Passwort muss ein Sonderzeichen enthalten'};
      }

      return null;
    };
  }

  validatePasswordsEqual(): ValidatorFn {
    return x => {

      if (this.passwordForExistingBenutzer) {
        return null;
      }

      if (this.ctrlPassword1.value !== x.value) {
        return {message: 'Die Passwörter stimmen nicht überein'};
      }

      return null;
    };
  }

  changePassword1(): void {
    if (this.passwordForExistingBenutzer) {
      this.ctrlPassword2.setValue(this.ctrlPassword1.value);
    }

    this.ctrlPassword2.updateValueAndValidity();
  }

  private resetErrors(): void {
    this.errFailure = false;
    this.errNotEqual = false;
    this.errWeak = false;
    this.errInvalidKey = false;
  }

  public activateAccount(): void {
    const key = this.ctrlActivationCode.value;
    const email = this.ctrlEmail.value;
    const password = this.ctrlPassword1.value;

    this.resetErrors();

    if (!this.passwordForExistingBenutzer && this.ctrlPassword1.value !== this.ctrlPassword2.value) {
      this.errNotEqual = true;
      return;
    }

    this.loading = true;
    this.apiService.activateAccount(key, email, password).toPromise().then(value => {
      this.loading = false;
      this.finished = true;
      this.stepper.next();
    }).catch(err => {
      this.loading = false;

      if (err.status === 401) {
        this.errInvalidKey = true;
      } else if (err.status === 400) {
        this.errWeak = true;
      } else {
        this.errFailure = true;
      }

    });
  }

  public selectionChange($event): void {
    if ($event.selectedIndex === 3) {
      this.resetErrors();
    }
  }

  public goToLogin(): void {
    this.router.navigate(['login']);
  }

  emailCompleted(): void {
    this.apiService.checkActivationExistingBenutzer(this.ctrlEmail.value).toPromise().then(value => {
      this.passwordForExistingBenutzer = value;
      this.stepper.next();
    });
  }
}
